// Run now and Resume, the two connector actions both Settings → Connectors and Sync health offer:
// one confirm wording, one request shape. Each resolves false when the person cancels.
import { CONFIRM } from "./connectors";

type Api = <T>(method: string, path: string, body?: unknown) => Promise<T>;
interface Target { id: string; name: string; updatedAt: string }

export async function runNow(api: Api, c: Target): Promise<boolean> {
  if (!window.confirm(CONFIRM.runNow(c.name))) return false;
  await api("POST", `/api/connectors/${c.id}/run-now`);
  return true;
}

/** Resume also turns a connector on, so it carries the version the screen showed: if another
 *  admin turned it off (or changed it) since, this answers 409 connector_changed rather than
 *  silently undoing that. */
export async function resume(api: Api, c: Target): Promise<{ connector: unknown } | false> {
  if (!window.confirm(CONFIRM.resume(c.name))) return false;
  return api<{ connector: unknown }>("PATCH", `/api/connectors/${c.id}`, { resume: true, ifUpdatedAt: c.updatedAt });
}
